import languageSetsFile from '../config/languageSets';

let privateState = {}; // private variables for this service.
let alreadyInitiated = false;
let service = {};
service.initService = (user) => {
  privateState.user = user;
  if (alreadyInitiated) return service;
  alreadyInitiated = true;
  return service;
};

service.language = 'ENGLISH';
service.languagesHashes = [
  {key: 'ENGLISH', value: 'ENGLISH'},
  {key: 'ITALIAN', value: 'ITALIAN'},
  {key: 'HEBREW', value: 'HEBREW'},
  {key: 'RUSSIAN', value: 'RUSSIAN'},
  {key: 'PORTUGUES', value: 'PORTUGUES'},
  {key: 'SPANISH', value: 'ESPANOL'},
  {key: 'JAPANESE', value: 'JAPANESE'},
  {key: 'FRENCH', value: 'FRENCH'},
  {key: 'GERMAN', value: 'GERMAN'},
  {key: 'TURKISH', value: 'TURKISH'},
  {key: 'DUTCH', value: 'DUTCH'},
  {key: 'GREEK', value: 'GREEK'},
  {key: 'POLISH', value: 'POLISH'},
  {key: 'CROATIAN', value: 'CROATIAN'},
  {key: 'SLOVAK', value: 'SLOVAK'},
  {key: 'ARABIC', value: 'ARABIC'},
  {key: 'AZERBAIJANI', value: 'AZERBAIJANI'},

  // {key: 'NORWEGIAN', value: 'NORWEGIAN'},
];

service.languagesLocaleKeys = [
  {key: 'ENGLISH', value: 'en'},
  {key: 'ITALIAN', value: 'it'},
  {key: 'HEBREW', value: 'he'},
  {key: 'RUSSIAN', value: 'ru'},
  {key: 'PORTUGUES', value: 'pt'},
  {key: 'SPANISH', value: 'es'},
  {key: 'JAPANESE', value: 'ja'},
  {key: 'FRENCH', value: 'fr'},
  {key: 'GERMAN', value: 'de'},
  {key: 'TURKISH', value: 'tr'},
  {key: 'DUTCH', value: 'nl'},
  {key: 'GREEK', value: 'el'},
  {key: 'POLISH', value: 'pl'},
  {key: 'CROATIAN', value: 'hr'},
  {key: 'SLOVAK', value: 'sk'},
  {key: 'ARABIC', value: 'ar'},
  {key: 'AZERBAIJANI', value: 'az'},
];

service.getLanguageSet = function (language) {
  if (language) return service.languageSets[language];
  return service.languageSets[service.language];
};

service.getLanguagesEnumHash = function () {
  return service.languagesHashes;
};

service.getLanguagesLocaleKeys = function () {
  return service.languagesLocaleKeys;
};

service.getLanguageLocalKey = (language) => {
  const languagesLocaleKeys = service.languagesLocaleKeys;
  const languageObj = languagesLocaleKeys.find(
    (languageObj) => languageObj.key === language,
  );
  return languageObj.value || 'en';
};

service.languageSets = languageSetsFile;

const languagesService = {...service};
export default languagesService;
